module.exports = __webpack_public_path__ + "dna-488d52a276ed3269016f49f79e79d68d.png";